import axios from 'axios';
import { localStorageService } from './index';

/**
 * Applies an auth token to the app's HTTP layer and persistence: sets (or clears) the
 * default axios `Authorization` header and mirrors the token into local storage.
 *
 * Previously performed inline inside the SET_AUTH_TOKEN reducer case. Extracted so the
 * reducer stays a pure state transition; the App dispatch layer invokes this on every
 * SET_AUTH_TOKEN dispatch, preserving the original behavior.
 */
export const applyAuthToken = (token?: string): void => {
  axios.defaults.headers.common = {
    ...axios.defaults.headers.common,
    Authorization: token && `Bearer ${token}`,
  };
  localStorageService.setAuthToken(token);
};
